import {DependencyList, EffectCallback, useEffect, useRef} from "react";


export function useChangeEffect(effect: EffectCallback, deps?: DependencyList) {
    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
        } else {
            effect()
        }
    }, deps)
}